import { useEffect, useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { PrimaryButton } from "./Buttons";

// Compact bottom bar: appears after the hero CTA scrolls out of view,
// hidden while the closing CTA is visible or the dialog / menu is open.
export const MobileCTA = ({ onBuild, suppressed }) => {
  const [pastHero, setPastHero] = useState(false);
  const [closingVisible, setClosingVisible] = useState(false);
  const reduce = useReducedMotion();

  useEffect(() => {
    const heroCta = document.getElementById("hero-cta");
    const closing = document.getElementById("closing");
    if (!heroCta || !closing) return undefined;
    const heroObs = new IntersectionObserver(([entry]) => setPastHero(!entry.isIntersecting));
    const closingObs = new IntersectionObserver(([entry]) => setClosingVisible(entry.isIntersecting), {
      threshold: 0.15,
    });
    heroObs.observe(heroCta);
    closingObs.observe(closing);
    return () => {
      heroObs.disconnect();
      closingObs.disconnect();
    };
  }, []);

  const show = pastHero && !closingVisible && !suppressed;

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="mobile-cta-bar"
          initial={reduce ? { opacity: 0 } : { y: 84, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={reduce ? { opacity: 0 } : { y: 84, opacity: 0 }}
          transition={{ duration: 0.24, ease: "easeOut" }}
          className="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-ink/90 px-4 pt-3 backdrop-blur-md md:hidden"
          style={{ paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom))" }}
        >
          <PrimaryButton testId="mobile-cta-button" onClick={onBuild} className="w-full">
            Request a launch proposal
          </PrimaryButton>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
